<template>
  <Fragment>
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[{ text: $t('meta.fractions'), name: 'fractions' }, { text: $t('fractions.newFraction') }]"
        />
      </template>
    </SectionHeader>
    <div class="body-content cf">
      <CompanyNav data-testid="new-fractions__company-nav" />
      <FractionsForm
        @submit="createFraction"
        :companyUuid="companyUser.company_uuid"
        data-testid="new-fractions__form"
      />
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import FractionsForm from '@/components/Fractions/FractionsForm.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav.vue'

import fractionsApi from '@/api/companies/fractions'

export default {
  components: {
    BreadCrumbs,
    CompanyNav,
    Fragment,
    FractionsForm,
    SectionHeader,
  },
  inject: ['companyUser'],
  data: () => ({
    formData: {
      name: null,
      translations: {},
      avvNumber: null,
    },
  }),
  methods: {
    async createFraction(formData) {
      const { name, translations, avvNumber, internalId } = formData
      const response = await fractionsApi.create(this.companyUser.company_uuid, {
        name,
        translations,
        avv_number: avvNumber,
        internal_id: internalId,
      })
      if (response.success) this.$router.push(`/company/fractions`)
    },
  },
}
</script>
